'use client';
import Script from 'next/script';
import { PropsWithChildren } from 'react';

import { HotjarScript } from '@/components/3rdParty/HotjarScript';

export const ExternalMainScripts = ({ children }: PropsWithChildren) => (
  <>
    {children}
    <HotjarScript />
    <Script strategy="lazyOnload" src="/pixels/customer-io.js" />
  </>
);
